"use client";

import Link from "next/link";
import type { MouseEvent } from "react";
import {
  type LinkProps,
  LinkProvider,
} from "@/scott/ui/elements/button/link-provider";
import {
  ProductVariantSelector,
  type ProductVariantSelectorProps,
} from "@/scott/ui/elements/product-variant-selector/product-variant-selector";
import { useVariantSwitch } from "./product-variant-switch-context";

function SizeLink(props: LinkProps) {
  return <Link {...props} scroll={false} />;
}

export function ProductSizeSelector(props: ProductVariantSelectorProps) {
  const switchVariant = useVariantSwitch();

  // Inside the hero switcher each size still renders as a real link (shareable,
  // works without JS), but a plain left-click is intercepted and swaps the
  // variant client-side instead of triggering an RSC navigation + refetch.
  const handleClickCapture = (event: MouseEvent<HTMLDivElement>) => {
    if (!switchVariant) {
      return;
    }

    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    ) {
      return;
    }

    const target = (event.target as HTMLElement).closest<HTMLElement>(
      "[data-variantcode]"
    );
    const articleCode = target?.getAttribute("data-variantcode");

    if (!(target && articleCode) || target.hasAttribute("disabled")) {
      return;
    }

    event.preventDefault();
    switchVariant(articleCode, target.getAttribute("href") ?? undefined);
  };

  return (
    <div onClickCapture={handleClickCapture}>
      <LinkProvider component={SizeLink}>
        <ProductVariantSelector {...props} />
      </LinkProvider>
    </div>
  );
}
